import { Col, Container, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import ConsignContactForm from "./common/ConsignContactForm";

const ConsignWithUsContainer = () => {
  const consignImages = [
    "/assets/images/other/consign/1.png",
    "/assets/images/other/consign/2.png",
  ];

  return (
    <>
      <Breadcrumbs title="Consign With Us" url={routes.Home.CarDemo1} mainClass="page-breadcrumbs-section page-breadcrumbs-section-consignwithus" />

      <section className="contact-section contact-2-section mb-5">
        <Container>

          {/* Image Slideshow */}
          <Row className="justify-content-center section-t-md-space mb-4">
            <Col lg={8} md={10}>
              <div className="consign-slideshow-section">
                <Swiper
                  modules={[Autoplay, Navigation, Pagination]}
                  spaceBetween={0}
                  slidesPerView={1}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  loop={true}
                  navigation={true}
                  pagination={{ clickable: true }}
                  style={{ borderRadius: "12px", overflow: "hidden" }}
                >
                  {consignImages.map((img, index) => (
                    <SwiperSlide key={index}>
                      <img
                        src={img}
                        alt={`consign-${index + 1}`}
                        className="img-fluid w-100"
                        style={{ display: "block", maxHeight: "420px", objectFit: "cover" }}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>

          {/* Consign Form */}
          <Row className="justify-content-center mb-5">
            <Col lg={8} md={10}>
              <ConsignContactForm />
            </Col>
          </Row>

        </Container>
      </section>
    </>
  );
};

export default ConsignWithUsContainer;
